import { render, staticRenderFns } from "./MojeLigeNatjecatelji.vue?vue&type=template&id=145e6304&scoped=true&"
import script from "./MojeLigeNatjecatelji.vue?vue&type=script&lang=js&"
export * from "./MojeLigeNatjecatelji.vue?vue&type=script&lang=js&"
import style0 from "./MojeLigeNatjecatelji.vue?vue&type=style&index=0&id=145e6304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145e6304",
  null
  
)

export default component.exports